module.exports = __webpack_public_path__ + "src/assets/img/Diagram.7faf2e07.png";